import ImageUploader1 from '../Uploader/Images/ImageUploader1'
import { LogoInputProps } from 'Types/Presentation/Components/LogoInput'

const LogoInput: React.FC<LogoInputProps> = ({ wording, description, image, changeImage }) => {
	return (
		<div className="d-flex flex-column flex-lg-row align-items-start my-5">
			<label className="form-label col-12 col-lg-3 mb-0 d-flex flex-column">
				<div>{wording}</div>
				<div className="text-kumopack-grey-600 fs-8">
					{description ?? 'JPG or PNG (max. 500x500px)'}
				</div>
			</label>

			<ImageUploader1
				formKey={`logo-input-${wording.replace(' ', '')}`}
				image={image ?? null}
				changeImage={changeImage ?? (() => {})}
			/>
		</div>
	)
}

export default LogoInput
